import IPOItemComponent from "../../components/IPOItemComponent";
import { Col, Row } from "react-bootstrap";
import * as querySelectors from "../../../../selectors/query";
import _ from "lodash";
import EmptyItemView from "../../../../components/EmptyItemView";
import LoadingOverlay from "../../../../components/LoadingOverlay";
import IPOListTableComponent from "../../components/IPOListTableComponent";
import { useForm } from "react-hook-form";

function OfferingTab({ data }) {
  const isLoading = querySelectors.getQueryIsLoading(data);

  const { data: ipoData } = querySelectors.getQueryData(data);
  return (
    <div className="pb-4">
      <IPOListTableComponent loading={isLoading} data={ipoData}></IPOListTableComponent>
      {/*{!_.isEmpty(ipoData) ? (*/}
      {/*  <Row className="row-gap-3">*/}
      {/*    {_.map(ipoData, (item,index) => {*/}
      {/*      return (*/}
      {/*        <Col lg={6} xl={4} md={6} key={index}>*/}
      {/*          <IPOItemComponent item={item} />*/}
      {/*        </Col>*/}
      {/*      );*/}
      {/*    })}*/}
      {/*  </Row>*/}
      {/*) : (*/}
      {/*  <div className="position-relative">*/}
      {/*    <EmptyItemView extraCss={{ height: "60vh" }} />*/}
      {/*    <LoadingOverlay loading={isLoading}> </LoadingOverlay>*/}
      {/*  </div>*/}
      {/*)}*/}
    </div>
  );
}
export default OfferingTab;
